// Toto je jediný skript, který by měl přistupovat k neobvyklým globálním proměnným.
// Pokud jsou ve zbytku aplikace potřeba jejich data, tak by jim měli být předány v konstruktoru.
/* global process */

// Polyfill se načítají jako první modul aplikace
import './polyfill';

import * as Sentry from '@sentry/browser';
import * as SentryIntegrations from '@sentry/integrations';
import Vue from 'vue';

import AppRoot from './app-root';
import ConfigParser from './config/config-parser';
import Randomizer from './randomizer/randomizer';

import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import * as fas from '@fortawesome/free-solid-svg-icons';
import * as far from '@fortawesome/free-regular-svg-icons';

Vue.component('font-awesome-icon', FontAwesomeIcon);

library.add(fas.faArrowAltCircleDown);
library.add(fas.faArrowAltCircleUp);
library.add(fas.faArrowAltCircleLeft);
library.add(fas.faArrowAltCircleRight);

library.add(fas.faCaretSquareDown);
library.add(fas.faCaretSquareUp);
library.add(fas.faCaretSquareLeft);
library.add(fas.faCaretSquareRight);

library.add(fas.faArrowDown);
library.add(fas.faArrowUp);
library.add(fas.faArrowLeft);
library.add(fas.faArrowRight);

library.add(fas.faAngleDown);
library.add(fas.faAngleUp);
library.add(fas.faAngleLeft);
library.add(fas.faAngleRight);

library.add(fas.faAngleDoubleDown);
library.add(fas.faAngleDoubleUp);
library.add(fas.faAngleDoubleLeft);
library.add(fas.faAngleDoubleRight);

library.add(far.faArrowAltCircleDown);
library.add(far.faArrowAltCircleUp);
library.add(far.faArrowAltCircleLeft);
library.add(far.faArrowAltCircleRight);

library.add(far.faCaretSquareDown);
library.add(far.faCaretSquareUp);
library.add(far.faCaretSquareLeft);
library.add(far.faCaretSquareRight);

// Načtou se nastavení předaná přes webpack DefinePlugin.
const environment = process.env.NODE_ENV;
const version = process.env.VERSION;
// Načte se konfigurace aplikace z URL parametrů.
const configParser = new ConfigParser();
const config = configParser.parseLocation(window.location);
// Spuštění logování chyb na Sentry
Sentry.init({
	dsn: config.sentryDsn,
	environment,
	integrations: (integrations) => [
		...integrations,
		new SentryIntegrations.Vue({Vue})
	],
	release: version
});
try {
	// Přidání zajímavých hodnot z konfigurace do logování na Sentry.
	Sentry.setExtras({
		...Object.fromEntries(
			config.guid.map((guid, index) => [`guid${index + 1}`, guid])
		),
		serverUrl: config.serverUrl
	});
	// Inicializace služeb
	Sentry.addBreadcrumb({message: 'Initializing the services.'});
	const randomizer = new Randomizer();
	// Inicializace GUI
	Sentry.addBreadcrumb({message: 'Initializing the user interface.'});
	Object.assign(Vue.config, {devtools: false, productionTip: false});
	// Nevhodný způsob spuštění, který Vue vyžaduje.
	// Volání `new` by mělo jen inicializovat hodnoty, místo toho se spustí celé GUI.
	// eslint-disable-next-line no-new
	new Vue({
		components: {AppRoot},
		el: '#app',
		template: '<AppRoot/>',
		created () {
			this.Sentry = Sentry;
			this.config = config;
			this.randomizer = randomizer;
		}
	});
} catch (error) {
	Sentry.captureException(error);
}
